import styled from "styled-components";

export const StyledAutocompleteList = styled.ul`
  position: absolute;
  z-index: 999;
  width: calc(100% - 10px);
  margin: 0;
  padding: 0;
  background-color: white;
  list-style: none;
  box-shadow: 0px 31px 39px -1px rgba(224, 224, 224, 1);
  
`;

export const StyledAutocompleteListItem = styled.li`
  padding: 15px;
  font-size: 12px;
  border-bottom: 1px solid lightgray;

  &:last-of-type {
    border: none;
  }
`;